import "../../styles/common.scss";

const Column = ({
  children,
  className,
  justify,
  align,
  fluid,
  style,
  childrenMargin,
  flexBasis,
  ...props
}) => (
  <div
    className={`column ${className ?? ""}${
      childrenMargin ? ` children-margin ${childrenMargin}` : ""
    }`}
    style={{
      justifyContent: justify,
      alignItems: align,
      height: fluid && "100%",
      flexBasis: flexBasis ? `${flexBasis}%` : undefined,
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
);

export default Column;
